var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLyjq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "d4ivul02ic"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94D87B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B85B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "8mvt5ozueb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E89D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92CD89",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.471211%",
    y1: "14.7209959%",
    x2: "90.6264681%",
    y2: "87.9987595%",
    id: "uc210qycve"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7E8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "uyi6ufmv0a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-49.2%",
    y: "-48.9%",
    width: "198.4%",
    height: "197.8%",
    filterUnits: "objectBoundingBox",
    id: "6dkkmqkl2d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.415686275 0 0 0 0 0.729411765 0 0 0 0 0.364705882 0 0 0 1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#uyi6ufmv0a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,4 C35.3506307,4 41.0997889,6.58913593 45.2614593,10.7744092 C49.4251707,14.9617352 52,20.7466044 52,27.1361163 C52,32.6616494 48.5782888,39.4412816 44.3475291,45.410863 C38.7842583,53.2606113 31.7296255,60 29,60 C26.2703745,60 19.2157417,53.2606113 13.6524709,45.410863 C9.42171119,39.4412816 6,32.6616494 6,27.1361163 C6,20.7466044 8.57482926,14.9617352 12.7385407,10.7744092 C16.9002111,6.58913593 22.6493693,4 29,4 Z",
    stroke: "url(#8mvt5ozueb)",
    strokeWidth: 2,
    fill: "url(#d4ivul02ic)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#6dkkmqkl2d)",
    transform: "translate(16.799962 13.437179)",
    fill: "url(#uc210qycve)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2928244,10.041254 C23.5448658,9.20288771 22.6358798,8.46790032 21.5925748,7.87592765 C20.3920794,7.18611163 19.0243873,6.68740528 17.5398056,6.43125843 C17.2236693,6.37518363 16.9016897,6.33298373 16.5741428,6.30096836 C14.6006106,6.10772594 12.7009589,6.36447189 11.0193624,6.97341079 C11.7165376,6.34647524 12.4845336,5.61048138 13.2513259,4.78903334 C15.0386522,2.874462 16.1859818,1.17628191 16.6953961,0.36159162 C16.8436085,0.124615632 16.5274973,-0.0673567107 16.1439757,0.022602605 C15.0304517,0.284045422 13.985015,0.641726029 13.0416718,1.08819173 C11.9729375,1.58855157 11.0209423,2.20465558 10.2309025,2.92778098 C10.0619253,3.08112403 9.90157504,3.2405059 9.74739401,3.40513577 C8.775562,4.44251974 8.20232353,5.59186165 8.01599221,6.76221963 C7.41328683,6.0187731 6.55681472,5.52104924 5.48198635,5.33406131 C5.33139151,5.30782117 5.17936721,5.28709267 5.02448399,5.27372098 C4.29656296,5.20734182 3.50765162,5.2712048 2.68016994,5.45318435 C1.93690102,5.61369251 1.14793952,5.87470398 0.331743078,6.22984442 C0.0461018989,6.35409565 -0.101358149,6.61915696 0.0788039398,6.69361184 C0.700368171,6.95074121 2.06251795,7.4493517 3.92390028,7.77245284 C4.57701293,7.88582461 5.20524796,7.96258001 5.78014157,8.01395796 C4.81299917,8.34940035 3.91131101,8.95920192 3.16280072,9.86433082 C3.0005445,10.0605927 2.84949823,10.2638998 2.71277167,10.4769601 C2.06419819,11.4738456 1.6898302,12.6192814 1.57865834,13.8171256 C1.47834537,14.8281976 1.57346713,15.8513951 1.83731533,16.8312905 C1.92386033,17.15281 2.35177038,17.3058655 2.58923626,17.1076866 C3.38935757,16.4400608 4.94774457,15.0459308 6.44626982,13.159325 C7.30740648,12.0751401 8.00435591,11.0096468 8.5260084,10.1330586 C9.05591166,10.568549 9.55241068,11.0393617 10.0158566,11.5419741 C12.1686982,13.856402 13.507776,16.8360832 13.7069976,20.0999726 C13.6797877,20.0998528 13.6525026,20.099733 13.6251673,20.099733 C9.74365735,20.099733 6.28968127,21.6956364 4.0858054,24.5384615 L23.1695198,24.5384615 C22.1262398,23.1029943 20.8151744,22.2006692 19.3020286,21.4440426 C19.1024446,21.3428418 18.8999867,21.2469033 18.6948843,21.1563358 C18.5731796,18.1150921 17.4772855,15.2559238 15.5481669,12.9225887 C14.6659645,11.8542916 13.6733677,10.8951009 12.5620003,10.0778944 C13.6320889,10.255201 14.8288226,10.4216042 16.107512,10.5468619 C19.5610366,10.8849882 22.4958931,10.8130016 23.9122871,10.742309 C24.327332,10.7217722 24.5444344,10.3233774 24.2927993,10.041278"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyjq);
export default __webpack_public_path__ + "static/media/lyjq.1b2367f51fd4e25162dc6dbca2f4e46f.svg";
export { ForwardRef as ReactComponent };